import React from 'react';

/**
 * Content surface fills — background only.
 * Call sites keep their own padding / margin / shadow unless noted.
 *
 * Exactly one host paints `background.paper` per content block.
 * TabSubBlock / paper Group set SurfaceHostContext so nested DataGrids
 * inherit that same paper (transparent cells) instead of nesting another card.
 */

/** Page floor and recessed insets inside surfaces. */
export const canvasBgSx = { bgcolor: 'background.default' } as const;

/** Elevated content fill — cards, table hosts, panels. */
export const surfaceBgSx = { bgcolor: 'background.paper' } as const;

/** Recessed area inside a surface (same token as canvas). */
export const insetBgSx = canvasBgSx;

/** Shared outline for surface cards (Paper, tab content, list grids). */
export const surfaceBorderSx = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2,
} as const;

/** Paper fill + shared border/radius. */
export const surfaceCardSx = {
  ...surfaceBgSx,
  ...surfaceBorderSx,
} as const;

/** Ancestor already paints the paper content surface. */
export const SurfaceHostContext = React.createContext(false);

export function useInsideSurfaceHost() {
  return React.useContext(SurfaceHostContext);
}
